import React, { ChangeEvent, KeyboardEvent, ReactElement, RefObject } from 'react';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { CloudIcon, DocumentIcon, FolderIcon, GalleryIcon, VideoIcon } from 'reactApp/ui/VKUIIcons';

export interface IState {
    active: boolean;
    focus: boolean;
    value: string;
    type: string;
}

export enum EActions {
    close = 'close',
    removeType = 'removeType',
    setFocus = 'setFocus',
    setType = 'setType',
    setActive = 'setActive',
    setValue = 'setValue',
}

export interface IAction {
    type: EActions;
    payload?: boolean | string;
}

export interface IOption {
    id: string;
    text: string;
    icon: ReactElement;
}

export interface ISearchProps {
    dropdownAvailable?: boolean;
    toggleSearch: (state: boolean) => void;
    isExpanded: boolean;
    onlyExpanded?: boolean;
    storage: EStorageType;
}

export interface ISearchContentProps extends ISearchProps {
    rootRef: RefObject<HTMLElement>;
    dropdownRef: RefObject<HTMLElement>;
}

export interface ISearchContent {
    isActive: boolean;
    isFocus: boolean;
    value: string;
    searchOption: IOption;
    placeholder: string;
    onSearchClick: () => void;
    onInputClick: () => void;
    onDocumentClick: (event: Event) => void;
    onInputChange: (event: ChangeEvent<HTMLInputElement>) => void;
    onKeyUp: (event: KeyboardEvent) => void;
    setActiveInput: () => void;
    chooseSearchType: (type: string) => void;
    removeSearchType: () => void;
    removeFocus: () => void;
}

export const typesOptions = {
    image: {
        id: 'image',
        text: 'Изображения',
        icon: <GalleryIcon />,
    },
    audio: {
        id: 'audio',
        text: 'Музыка',
        icon: <CloudIcon />,
    },
    video: {
        id: 'video',
        text: 'Видео',
        icon: <VideoIcon />,
    },
    document: {
        id: 'document',
        text: 'Документы',
        icon: <DocumentIcon />,
    },
    archive: {
        id: 'archive',
        text: 'Архивы',
        icon: <CloudIcon />,
    },
    folder: {
        id: 'folder',
        text: 'Папки',
        icon: <FolderIcon />,
    },
} as const;

export const typesOptionsList = Object.values(typesOptions);
